// extracted by mini-css-extract-plugin
export default {"cls1":"AgilysysLogo_cls1__ibaOl","cls2":"AgilysysLogo_cls2__4fajY"};